import { frenchTime } from '../follows';

export const mutations = {
    FETCH_INFO(state, info) {
        return state.info = info;
    },
    FETCH_COMICS(state, comics) {
        if (comics != null) {
            return state.comics = comics.map(c => c['last_chapter'] != null ? {...c, last_chapter: {...c['last_chapter'], time: frenchTime(c['last_chapter']['published_on'])}} : c);
        }
        return state.comics = comics;
    },
    FETCH_LATEST_CHAPTERS(state, chapters) {
        state.latest_chapters = chapters != null ? chapters.map(c => c.last_chapter != null ? {
            ...c, last_chapter: {...c.last_chapter, time: frenchTime(c.last_chapter.published_on)}
        } : c) : [];
    },
    FETCH_COMIC(state, comic) {
        if (!comic) return;
        if (comic['chapters'] != null) {
            comic['chapters'] = comic['chapters'].map(c => { return {...c, time: timePassed(c['published_on'])} });
        }
        return state.comics_obj[comic.slug] = comic;
    },
    FETCH_CHAPTER(state, chapter) {
        if (!chapter) return;
        return state.chapters_obj[chapter.url] = chapter;
    },
    SET_RATING(state, payload) {
        if (payload.vote_token) state.vote_token = payload.vote_token;
        return state.ratings[payload.slug] = {
            average: payload.average !== undefined ? payload.average : null,
            count: payload.count !== undefined ? payload.count : 0,
            your_vote: payload.your_vote !== undefined ? payload.your_vote : null,
        };
    },
    TOGGLE_FOLLOW(state, slug) {
        const index = state.follows.indexOf(slug);
        if (index === -1) state.follows.push(slug); else state.follows.splice(index, 1);
    },
    SET_FOLLOWS(state, list) {
        state.follows = Array.isArray(list) ? list : [];
    },
};
